import { FunctionalComponent, h } from '@stencil/core';
import { AppLink, AppMedia } from '../functional/.'

interface SectionsContact {
    __component: string;
    data?: any;
}


export const SectionsContact: FunctionalComponent<SectionsContact> = ({ data }) => {

    const { AddressLabel, Address, EmailLabel, Email, PhoneLabel, Phone, SocialLabel, Social, Directions, Map, RemoveTopMargin } = data;

    return [
        <section class={`uk-section uk-container uk-container-large uk-position-relative ${RemoveTopMargin ? 'uk-padding-remove-top' : ''}`}>
            <div class="uk-cover-container  uk-flex uk-flex-middle" style={{ 'min-height': 'calc(100vh - 176px)' }}>
                <AppMedia className='uk-visible@s' size="(max-width: 638px) 100vw, (max-width: 958px) 90vw, 90vw" media={Map} cover />
                <div class="uk-position-relative uk-width-1-1">
                    <div class="uk-width-1-1 uk-width-5-6@s uk-width-2-3@m uk-width-1-2@l">
                        <div class="uk-background-primary-diag uk-light uk-child-width-1-1 uk-child-width-1-2@s uk-grid-collapse" uk-grid>
                            <div>
                                <div class="uk-padding">
                                    <h2 class="uk-heading-small wsio-gold uk-margin-small-bottom">{PhoneLabel}</h2>
                                    <AppLink className="uk-button uk-button-text" data={Phone} />
                                    <h2 class="uk-heading-small wsio-gold uk-margin-small-bottom">{EmailLabel}</h2>
                                    <AppLink className="uk-button uk-button-text uk-text-lowercase" data={Email} />
                                    <br />
                                    <AppLink className="uk-margin-small-top uk-button uk-button-text uk-text-lowercase" data={{ URL: 'mailto:spares@howardsongroup.com', Label: 'spares@howardsongroup.com'}} />
                                    <h2 class="uk-heading-small wsio-gold">{SocialLabel}</h2>
                                    <div class="uk-flex">
                                        {Social.map((Link) => <span uk-tooltip={Link.Icon}><AppLink className="color-primary uk-margin-right uk-icon-button" data={Link} /></span>)}
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div class="uk-padding">
                                    <h2 class="uk-heading-small wsio-gold uk-margin-small-bottom">{AddressLabel}</h2>
                                    <address style={{ 'white-space': 'pre-wrap' }}>
                                        {Address}
                                    </address>
                                    <AppLink className="uk-margin-top uk-button uk-button-default" data={Directions} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section >
    ]
};